<template>

    <AppHead :title="'Sign up for ' + account.name" />


    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900">
       <div class="sm:mx-auto sm:w-full sm:max-w-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="w-full flex flex-col items-center justify-center pb-4 space-y-2">
                       <div class="flex items-center justify-center w-24 h-24 rounded-lg bg-center bg-cover mb-4 bg-gray-300" :style="'background-image: url(' + account.logo + ')'">
                           <div v-if="!account.logo" class="text-gray-700 text-3xl font-medium">
                               {{ account.name.charAt(0).toUpperCase() }}
                           </div>
                       </div>
                       <div class="text-3xl font-bold tracking-tight">
                           Sign up for {{ account.name }}
                       </div>
                       <div class="text-center font-medium text-gray-800">
                           We suggest using the email address you use at <span class="font-bold">{{ account.name }}</span>.
                       </div>
                   </div>
                   <a :href="route('auth.redirect', token)" class="focus:ring-regal-blue-700 inline-flex items-center text-gray-800 border border-gray-500 justify-center w-full rounded-lg font-medium py-2 px-4 pr-8 transition-colors duration-150 ease-in-out hover:bg-gray-300 active:border-gray-600 active:bg-gray-400 hover:text-regal-blue-900">
                       <span class="flex rounded-lg items-center justify-center w-10 h-10 mr-1">
                           <svg class="c-button__icon" width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                       </span>
                       Sign Up with Google
                   </a>
                   <div class="flex w-full items-center py-2">
                       <div class="h-0.5 bg-gray-400 flex-1 rounded-full">
                       </div>
                       <div class="w-12 text-center text-gray-700 font-medium">
                           OR
                       </div>
                       <div class="h-0.5 bg-gray-400 flex-1 rounded-full">

                       </div>
                   </div>
                   <div class="w-full pb-2">
                       <form @submit.prevent="form.post(route('login.process', token))" class="flex flex-col justify-center w-full space-y-4">
                           <input type="email" v-model="form.email" name="email" class="w-full rounded-lg border-gray-500 py-3 focus:outline-none focus:border-regal-blue-700 focus:ring-regal-blue-700 placeholder-gray-600" placeholder="name@work-email.com" required>
                           <InlineError v-if="form.errors.email" :message="form.errors.email"/>
                           <button type="submmit" class="w-full rounded-lg bg-regal-blue-700 text-white py-3 font-medium" name="button">Sign Up with Email</button>
                       </form>
                   </div>
               </div>
           </div>

       </div>
   </div>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    // import Layout from '@/Shared/Layout'

    export default {
        setup () {
            const form = useForm({
                email: null,
            })

            return { form }
        },
        components: { InlineError },
        props: {
            'account': Object,
            'token': String
        },
        // layout: Layout,
    }
</script>
